<template>
    <div>
        <component 
            :is="theComponent" 
            v-bind:class="props.class"
            v-bind:data="props.data"
        ></component>
    </div>
</template>

<script setup lang="ts">
import { defineAsyncComponent } from 'vue';

const props = defineProps({
    path: String,
    class: String,
    data: Object
});

const theComponent = defineAsyncComponent(() => {
    if (!props.path) {
        return import('vue'); // Ou outro componente padrão de sua escolha
    }

    const pathArray = props.path.split("/").filter(n => n);
    const filename = pathArray[pathArray.length - 1].replace(/\.[^/.]+$/, "");

    switch (pathArray.length) {
        case 1:
            return import(`../${filename}.vue`);
        case 2:
            return import(`../${pathArray[0]}/${filename}.vue`);
        case 3:
            return import(`../${pathArray[0]}/${pathArray[1]}/${filename}.vue`);
        case 4:
            return import(`../${pathArray[0]}/${pathArray[1]}/${pathArray[2]}/${filename}.vue`);
        case 5:
            return import(`../${pathArray[0]}/${pathArray[1]}/${pathArray[2]}/${pathArray[3]}/${filename}.vue`);
        default:
            return import('vue'); // Ou outro componente padrão de sua escolha
    }
});
</script>
